var map = {
	"./ban.svg": "5ed3",
	"./checkmark.svg": "93fc",
	"./checkmark_dark.svg": "4946",
	"./checkmark_white.svg": "7fb0",
	"./copy.svg": "66ac",
	"./cross_white.svg": "896b",
	"./edit.svg": "1286",
	"./eye.svg": "aa27",
	"./github.svg": "599e",
	"./obs.svg": "d5e4",
	"./open.svg": "5c3b",
	"./params.svg": "f0a8",
	"./plug.svg": "1c58",
	"./quote.svg": "45b3",
	"./random.svg": "6e7f",
	"./reload.svg": "c22e",
	"./sadFace.svg": "7237",
	"./shoutout.svg": "a4b3",
	"./toxic.svg": "89eb",
	"./twitch.svg": "14a4",
	"./user_rate.svg": "3460"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cc5";